"use client"
import { AuthProvider, useAuth } from "./contexts/AuthContext"
import { LanguageProvider } from "./contexts/LanguageContext"
import { LoginForm } from "./components/LoginForm"
import { AppLayout } from "./components/AppLayout"

function AppContent() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loading-spinner" style={{ width: "48px", height: "48px", margin: "0 auto 16px" }}></div>
          <p>Loading...</p>
        </div>
      </div>
    )
  }

  return user ? <AppLayout /> : <LoginForm />
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </LanguageProvider>
  )
}

export default App
